/**
 * 域名初始化工具，在页面加载时根据域名设置相应的class
 */
import { IS_HUIYA, IS_DEERBOOK } from '../config/domain';

export function initDomainStyles() {
  console.log('======= 域名样式初始化 =======');
  console.log('IS_HUIYA:', IS_HUIYA);
  console.log('初始document.title:', document.title);
  
  // 为body添加域名相关的class
  if (IS_HUIYA) {
    document.body.classList.add('is-huiya');
    document.title = '绘芽';
    console.log('添加类名: is-huiya');
  } else {
    document.body.classList.add('is-deerbook');
    document.title = '奇鹿';
    console.log('添加类名: is-deerbook');
  }
  
  // 设置网站描述
  const description = document.querySelector('#description') as HTMLMetaElement;
  if (description) {
    description.content = IS_HUIYA ? '绘芽' : '奇鹿';
  }
  
  console.log('修改后document.title:', document.title);
  
  // 设置favicon和apple-touch-icon
  const favicon = document.querySelector('#favicon') as HTMLLinkElement;
  const appleTouchIcon = document.querySelector('#apple-touch-icon') as HTMLLinkElement;
  
  if (favicon) {
    favicon.href = IS_HUIYA ? '/favicon-huiya.ico' : '/favicon.ico';
    console.log('设置favicon:', favicon.href);
  }
  
  if (appleTouchIcon) {
    appleTouchIcon.href = IS_HUIYA ? '/logo256_huya.png' : '/logo256.png';
    console.log('设置apple-touch-icon:', appleTouchIcon.href);
  }
  
  // 输出body的类名列表
  console.log('Body类名列表:', document.body.className);
  console.log('域名样式初始化完成:', IS_HUIYA ? '绘芽' : '奇鹿');
}

// 自动调用初始化函数
initDomainStyles(); 